import { takeEvery, put, call, takeLatest } from 'redux-saga/effects';
import {
  AIAssistPortletsActionTypes,
  AIAssistPortletsActions,
  AIAssistPortletsAction,
} from '../../actions/cbo/AIAssistPortletsAction';

import {
  IEpicDiagramPayload,
  IEpicDiagramResponse,
  IEpicsListResponse,
  IEpicsResponse,
  ITestCasesBuild,
  ITestCasesPayload,
  IUserStoriesInBacklogBuildQAResponse,
  IUserStoriesForTestCasesResponse,
  IUserStoriesInBacklogBuildQAPayload,
  IUserStoriesShapeResponse,
  IDefectsBySprint,
  IDefectsByPriority,
  ITestCasesByStatusResponse,
  ISprintHealthResponse,
  ISprintBurnDownResponse,
  ISprintwiseCapacityResponse,
  ITestCasesResponse,
} from '../../../models/cbo/AIAssistPortletsModel';
import AIAssistPortletsService from '../../../services/cbo/AIAssistPortletsService/AIAssistPortletsService';

export function* getEpicsWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: IEpicsResponse[] = yield AIAssistPortletsService.getEpics(data);
    yield put(AIAssistPortletsActions.getEpicsSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getEpicsError(error));
    }
  }
}

export function* getEpicDiagramWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as IEpicDiagramPayload;
    const response: IEpicDiagramResponse = yield AIAssistPortletsService.getEpicDiagram(data);
    yield put(AIAssistPortletsActions.getEpicDiagramSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getEpicDiagramError(error));
    }
  }
}

export function* getUserStoriesForTestCasesWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: IUserStoriesForTestCasesResponse[] =
      yield AIAssistPortletsService.getUserStoriesForTestCases(data);
    yield put(AIAssistPortletsActions.getUserStoriesForTestCasesSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getUserStoriesForTestCasesError(error));
    }
  }
}

export function* getTestCasesWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as ITestCasesPayload;
    const response: ITestCasesResponse[] = yield AIAssistPortletsService.getTestCases(data);
    yield put(AIAssistPortletsActions.getTestCasesSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getTestCasesError(error));
    }
  }
}

export function* getEpicsListWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: IEpicsListResponse[] = yield AIAssistPortletsService.getEpicsList(data);
    yield put(AIAssistPortletsActions.getEpicsListSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getEpicsListError(error));
    }
  }
}

export function* getUserStoriesInBacklogBuildQAWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as IUserStoriesInBacklogBuildQAPayload;
    const response: IUserStoriesInBacklogBuildQAResponse[] =
      yield AIAssistPortletsService.getUserStoriesInBacklogBuildQA(data);
    yield put(AIAssistPortletsActions.getUserStoriesInBacklogBuildQASuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getUserStoriesInBacklogBuildQAError(error));
    }
  }
}
export function* getUserStoriesShapeWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: IUserStoriesShapeResponse[] =
      yield AIAssistPortletsService.getUserStoriesShape(data);
    yield put(AIAssistPortletsActions.getUserStoriesShapeSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getUserStoriesShapeError(error));
    }
  }
}

export function* getTestCasesBuildWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: ITestCasesBuild[] = yield AIAssistPortletsService.getTestCasesBuild(data);
    yield put(AIAssistPortletsActions.getTestCasesBuildSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getTestCasesBuildError(error));
    }
  }
}

export function* getDefectsBySprintWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: IDefectsBySprint = yield AIAssistPortletsService.getDefectsBySprint(data);
    yield put(AIAssistPortletsActions.getDefectsBySprintSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getDefectsBySprintError(error));
    }
  }
}

export function* getDefectsByPriorityWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: IDefectsByPriority = yield AIAssistPortletsService.getDefectsByPriority(data);
    yield put(AIAssistPortletsActions.getDefectsByPrioritySuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getDefectsByPriorityError(error));
    }
  }
}

export function* getTestCasesByStatusWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: ITestCasesByStatusResponse[] =
      yield AIAssistPortletsService.getTestCasesByStatus(data);
    yield put(AIAssistPortletsActions.getTestCasesByStatusSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getTestCasesByStatusError(error));
    }
  }
}

export function* getSprintHealthWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: ISprintHealthResponse = yield AIAssistPortletsService.getSprintHealth(data);
    yield put(AIAssistPortletsActions.getSprintHealthSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getSprintHealthError(error));
    }
  }
}

export function* getSprintBurnDownWorker(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: ISprintBurnDownResponse = yield AIAssistPortletsService.getSprintBurnDown(data);
    yield put(AIAssistPortletsActions.getSprintBurnDownSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIAssistPortletsActions.getSprintBurnDownError(error));
    }
  }
}

function* getSprintwiseCapacity(action: AIAssistPortletsAction) {
  try {
    const data = action.data as string;
    const response: ISprintwiseCapacityResponse[] =
      yield AIAssistPortletsService.getSprintwiseCapacity(data);
    yield put(AIAssistPortletsActions.getSprintwiseCapacitySuccess(response));
  } catch (error) {
    yield put(AIAssistPortletsActions.getSprintwiseCapacityError(error as Error));
  }
}

export function* aiAssistPortletsWatcher() {
  yield takeEvery(AIAssistPortletsActionTypes.GET_EPICS_STARTED, getEpicsWorker);
  yield takeEvery(AIAssistPortletsActionTypes.GET_EPIC_DIAGRAM_STARTED, getEpicDiagramWorker);
  yield takeEvery(
    AIAssistPortletsActionTypes.GET_USER_STORIES_FOR_TEST_CASES_STARTED,
    getUserStoriesForTestCasesWorker,
  );
  yield takeEvery(AIAssistPortletsActionTypes.GET_TEST_CASES_STARTED, getTestCasesWorker);
  yield takeEvery(AIAssistPortletsActionTypes.GET_EPIC_LIST_STARTED, getEpicsListWorker);
  yield takeEvery(
    AIAssistPortletsActionTypes.GET_USER_STORIES_BACKLOG_BUILD_QA_STARTED,
    getUserStoriesInBacklogBuildQAWorker,
  );
  yield takeEvery(
    AIAssistPortletsActionTypes.GET_USER_STORIES_SHAPE_STARTED,
    getUserStoriesShapeWorker,
  );
  yield takeEvery(
    AIAssistPortletsActionTypes.GET_TEST_CASES_BUILD_STARTED,
    getTestCasesBuildWorker,
  );
  yield takeEvery(
    AIAssistPortletsActionTypes.GET_DEFECTS_BY_SPRINT_STARTED,
    getDefectsBySprintWorker,
  );
  yield takeEvery(
    AIAssistPortletsActionTypes.GET_DEFECTS_BY_PRIORITY_STARTED,
    getDefectsByPriorityWorker,
  );
  yield takeEvery(
    AIAssistPortletsActionTypes.GET_TEST_CASES_BY_STATUS_STARTED,
    getTestCasesByStatusWorker,
  );
  yield takeEvery(AIAssistPortletsActionTypes.GET_SPRINT_HEALTH_STARTED, getSprintHealthWorker);
  yield takeEvery(AIAssistPortletsActionTypes.GET_SPRINT_BURNDOWN_STARTED, getSprintBurnDownWorker);
  yield takeLatest(
    AIAssistPortletsActionTypes.GET_SPRINTWISE_CAPACITY_STARTED,
    getSprintwiseCapacity,
  );
}
